import { Card, Row, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMoneyBillWave,
    faUsers,
    faCheckCircle,
    faClock,
} from "@fortawesome/free-solid-svg-icons";
import formatMoney from "../../../utils/formatMoney";
import { MetricInfo, buildMetricDocs } from "./dashboard-metric-info";

const CARDS = [
    {
        key: "totalCommission",
        title: "Tổng hoa hồng",
        icon: faMoneyBillWave,
        iconColor: "text-blue-600",
        bgColor: "bg-blue-50",
    },
    {
        key: "totalUserCommission",
        title: "Hoa hồng user",
        icon: faUsers,
        iconColor: "text-green-600",
        bgColor: "bg-green-50",
        subtitle: "Phần trả cho user",
    },
    {
        key: "totalPaid",
        title: "Đã chuyển khoản",
        icon: faCheckCircle,
        iconColor: "text-purple-600",
        bgColor: "bg-purple-50",
        subtitle: "Theo ngày chuyển khoản",
    },
    {
        key: "pendingPayments",
        title: "Chờ xử lý",
        icon: faClock,
        iconColor: "text-orange-500",
        bgColor: "bg-orange-50",
        subtitle: "Yêu cầu rút tiền (toàn hệ thống)",
        isPending: true,
    },
];

/** Dòng phụ của thẻ Tổng hoa hồng: số đơn đã duyệt + đơn còn chờ (nếu có). */
function commissionSubtitle(summary) {
    const parts = [];
    if (summary.totalOrders != null) {
        parts.push(`${summary.totalOrders.toLocaleString("vi-VN")} đơn đã duyệt`);
    }
    if (summary.pendingOrders) {
        parts.push(`${summary.pendingOrders.toLocaleString("vi-VN")} đơn chờ duyệt`);
    }
    return parts.join(" · ") || "Tất cả đơn đã duyệt";
}

function DashboardStatCards({ summary, timeField = "purchase" }) {
    const docs = buildMetricDocs(timeField);

    return (
        <Row gutter={[16, 16]}>
            {CARDS.map((card) => {
                const raw = summary[card.key] || 0;
                const displayValue = card.isPending
                    ? `${raw} yêu cầu`
                    : formatMoney.format(raw);
                const subtitle =
                    card.key === "totalCommission"
                        ? commissionSubtitle(summary)
                        : card.subtitle;

                return (
                    <Col key={card.key} xs={24} sm={12} xl={6}>
                        <Card size="small" className="shadow-sm h-full">
                            <div className="flex items-start gap-4">
                                <div className={`p-3 rounded-xl ${card.bgColor} flex-shrink-0`}>
                                    <FontAwesomeIcon
                                        icon={card.icon}
                                        className={`text-xl ${card.iconColor}`}
                                    />
                                </div>
                                <div className="min-w-0 flex-1">
                                    <div className="flex items-center gap-1 text-content-3 text-sm">
                                        <span className="truncate">{card.title}</span>
                                        <MetricInfo doc={docs[card.key]} />
                                    </div>
                                    <div className="text-base font-bold text-content truncate">
                                        {displayValue}
                                    </div>
                                    <div className="text-xs text-content-3 truncate">{subtitle}</div>
                                </div>
                            </div>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
}

export default DashboardStatCards;
